<template>
  <v-card flat>
    <v-card-title>
      Hardware Statistic
    </v-card-title>
    <v-card-text>
      <v-expansion-panels
        v-model="panel"
        accordion
      >
        <v-expansion-panel>
          <v-expansion-panel-header><b>Filters</b></v-expansion-panel-header>
          <v-expansion-panel-content>
            <presets-autocomplete
              @update="presetSelected"
            />
            <map-id-autocomplete
              v-model="map_id"
            />
            <v-autocomplete
              v-model="build_id"
              :items="builds"
              label="Build ID"
              background-color="grey lighten-2"
              class="pt-1"
              clearable
              hide-details
              dense
              solo
              flat
              item-text="build_id"
              item-value="build_id"
            />
            <v-autocomplete
              v-model="user_id"
              :items="users"
              label="User"
              class="pt-1"
              background-color="grey lighten-3"
              hide-details="auto"
              clearable
              dense
              solo
              flat
              item-text="user_name"
              item-value="user_id"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <HardwareStatisticTables
        :filters="filters"
        class="mt-3"
        @update-filters="updateFilters"
      />
      <HardwareFPSTable
        ref="hardwareFPSTable"
        class="mt-3"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import PresetsAutocomplete from '../../components/filters/Telemetry/PresetsAutocomplete.vue';
import MapIdAutocomplete from '../../components/filters/Telemetry/MapIdAutocomplete.vue';
import HardwareStatisticTables from '../../components/hardware-statistic-components/hardwareStatisticTables.vue'
import HardwareFPSTable from '../../components/hardware-statistic-components/hardwareFPSTable.vue'
export default {
  components: {
    PresetsAutocomplete,
    MapIdAutocomplete,
    HardwareStatisticTables,
    HardwareFPSTable
  },
  data () {
    return {
      panel: 0,
      builds: [],
      filters: []
    }
  },
  created () {
    if (this.$route.query.map_id) {
      this.map_id = this.$route.query.map_id
    }

    if (this.$route.query.build_id) {
      this.build_id = this.$route.query.build_id
    }

    if (this.$route.query.user_id) {
      this.user_id = this.$route.query.user_id
    }

    this.updateRouterQuery()
  },
  async mounted () {
    if (this.map_id || (this.$route.query.map_id === this.map_id && this.$route.query.map_id)) {
      await this.getSessions()
    }

    await this.getTelemetryHardwareFilters()
  },
  watch: {
    async map_id () {
      this.updateRouterQuery()
      await this.getSessions()
    },
    async build_id (val) {
      const build = this.builds.find(build => build.build_id === val)
      if (!build) return;

      if (build.users.every(user => user.id !== this.user_id)) {
        this.user_id = null
      }

      this.updateRouterQuery()
    },
    async user_id () {
      this.updateRouterQuery()
    }
  },
  computed: {
    users () {
      const build = this.builds.find(build => build.build_id === this.build_id)

      if (build) {
        return build.users
      } else {
        return []
      }
    },
    map_id: {
      get () {
        return this.$store.state.telemetry.map_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_MAP_ID', val)
      }
    },
    build_id: {
      get () {
        return this.$store.state.telemetry.build_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_BUILD_ID', val)
      }
    },
    user_id: {
      get () {
        return this.$store.state.telemetry.user_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_USER_ID', val)
      }
    },
  },
  methods: {
    async getTelemetryHardwareFilters () {
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/telemetry/hardware/filters')
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.filters = data
      }
    },
    async getSessions () {
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/data-for-filters/${this.map_id}`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.builds = data
        let build = this.builds.find(build => build.build_id === this.build_id)

        if (!build) {
          this.build_id = (data[0] || { build_id: null }).build_id
          build = data[0]
        }

        if (this.build_id) {
          if (build.users.every(user => user.user_id !== this.user_id)) {
            this.user_id = null
          }
        }
      }
    },
    async updateFilters (event) {
      this.filters = event
      await this.$refs.hardwareFPSTable.getData()
    },
    updateRouterQuery () {
      const flag = !(
        this.$route.query.map_id === this.map_id &&
        this.$route.query.build_id === this.build_id &&
        this.$route.query.user_id === this.user_id
      )

      if (flag) {
        this.$router.replace({
          path: "/telemetry/hardware-statistic",
          query: {
            map_id: this.map_id,
            build_id: this.build_id,
            user_id: this.user_id
          }
        })
      }
    },
    presetSelected ({ build_id, map_id }) {
      this.build_id = build_id
      this.map_id = map_id
    }
  }
}
</script>
